import React from 'react';
import './Searchnav.css';
import WelcomeName from './WelcomeName';

// function getUserInfo()
// {
//     if(localStorage.getItem('user')) {
//         console.log(localStorage.getItem('user'));
//     }
// }

function Searchnav() {
    return (
        <>
        <div className="searchnav-container">
            <div className="searchnav-wrap">
                <div className="searchnav-row">
                    <div className="searchnav-box">
                        <img src={process.env.PUBLIC_URL +"/images/Acc_Logo_Black_Purple_RGB.png"} className="acc-logo" alt="logo" />
                        <h2>Learning & Talent Transformation</h2>
                    </div>
                </div>
                <div className="searchnav-row">
                    <div className="searchnav-box" style={{textAlign:'right'}}>
                        {/* <p>{{profileName?.displayName}}</p> */}
                        {/* <p>Hello, {localStorage.getItem("empName")} ! </p> */}
                           <WelcomeName />
                            {/* {console.log("user info from search nav",localStorage.getItem("empName") ) }  */}

                        <img src={process.env.PUBLIC_URL +"/images/user2.jpg"} className="user-img" alt="user-image" />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Searchnav
